// @core/api/endpoints/admin/get_audit_log.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  AuditLogResponse,
} from '../../../types/admin';

const BASE_PATH = '/admin';

/**
 * Get specific audit log entry
 * Retrieves detailed information for a specific audit log entry including the full before and after state of the affected resource.
 */
export async function GetAuditLog(
  log_id: string,
  options?: RequestOptions
): Promise<AuditLogResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/admin/audit-logs/:log_id`;
  requestPath = requestPath.replace(':log_id', encodeURIComponent(log_id));
  const requestOptions = options;
  return client.get<AuditLogResponse>(requestPath, { ...requestOptions });
}
